import { useState } from 'react';
import { ROUTES, SITE_NAME } from '../Constants';
import logo from '../images/logo.png';

const AppBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <nav className="bg-orange-100 text-black p-4">
            <div className="container mx-auto flex justify-between items-center">
                {/* Logo */}
                <div className="text-xl font-bold">
                    <img src={logo} style={{ width: '30px', float: 'left' }} alt="" />{SITE_NAME}</div>

                {/* Hamburger Menu Button (Mobile) */}
                <button
                    className="md:hidden block text-black"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16m-7 6h7"
                        />
                    </svg>
                </button>

                {/* Navigation Links */}
                <ul
                    className={`${isMenuOpen ? 'block' : 'hidden'
                        } md:flex space-y-4 md:space-y-0 md:space-x-4 absolute md:relative top-16 md:top-0 left-0 w-full md:w-auto bg-orange-200 md:bg-transparent p-4 md:p-0`}
                >
                    <li>
                        <a href={ROUTES.HOME} className="block hover:underline">
                            Home
                        </a>
                    </li>
                    <li>
                        <a href={ROUTES.EVENTS} className="block hover:underline">
                            Events
                        </a>
                    </li>
                    <li>
                        <a href={ROUTES.GALLERY} className="block hover:underline">
                            Gallery
                        </a>
                    </li>
                    <li>
                        <a href={ROUTES.BOARD} className="block hover:underline">
                            Board Members
                        </a>
                    </li>
                    <li>
                        <a href={ROUTES.CHARITY} className="block hover:underline">
                            Charity
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default AppBar;